import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ONBOARDING_STEP_EVENT } from '../../../constants/analyticEvents';
import { pushEvent } from '../../../utilities/analytics';
import { setCurrentStep, setDataV2 } from '../onboardingSlice';
import WizardXpButton from '../components/WizardXpButton';
import { getWizardV2State } from '../wizardService';
import { isMobile } from '../../../utilities/helpers';
import StyleStepDesktop from '../../wizardDesktop/steps/StyleStepDesktop';

const StyleStep = () => {
  const dispatch = useDispatch();

  const { formV2: form, step } = useSelector(state => state.onboarding);
  const data = getWizardV2State().hostingLevelPrefStep;

  const handleClick = (item) => {
    dispatch(setDataV2({ style: item }))
  }

  const handleContinueClick = () => {
    dispatch(setCurrentStep(1));
    pushEvent(ONBOARDING_STEP_EVENT, {
      step,
      stepName: 'style',
      question: data.title,
      selection: form.style?.id,
      skipAvailable: !!(localStorage.getItem('onboardingCompleted')),
      wizardV2: true,
    });
  }

  if (!isMobile()) {
    return (
      <StyleStepDesktop
        data={data}
        handleClick={handleClick}
        form={form}
        onContinueClick={handleContinueClick}
      />
    )
  }

  return (
    <div>
      <div className="wizard-step wizard-style-step">
        <div className="wizard-step__title">{data.title}</div>
        <div className="wizard-step__options">
          {data.items.map((item, index) => (
            <WizardXpButton
              key={index}
              label={item.text}
              iconUrl={item.icon}
              onClick={() => handleClick(item)}
              active={form.style?.text === item.text}
              className={`slide-in-bottom animation-delay-${index * 50}`}
            />
          ))}
        </div>
      </div>

      <div className="wizard-footer">
        <button className="wizard-control-button" onClick={handleContinueClick}>{data.buttonText}</button>
      </div>
    </div>
  )
}

export default StyleStep
